export const defaultLoadingPaneIconStyles = {
  borderRadius: "50%",
  backgroundColor: "#F1F1F1",
  boxShadow: "0px 0px 0.5px 7px rgba(196, 196, 196, 0.15)",
  width: "86px",
  height: "86px",
  margin: "0px 0px 20px 0px",
  display: "flex",
  order: 1,
  alignSelf: "auto",
  overflow: "visible"
};